var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ffd697815460a547b72eb1607578ca1bea5e633c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website@lit-fibre-ltd"]={id:"ffd697815460a547b72eb1607578ca1bea5e633c"};
      